'use strict';


const {getById, mk} = require('../utils/misc');
require('../linkh2s');
require('../extensions');

const Fitter = require('../classes/Fitter');

const drawingElements = [
    require('../drawing-elements/simple-triangle-example'),
    require('../drawing-elements/simple-square-example'),
    require('../drawing-elements/scale-example'),
    require('../drawing-elements/auto-triangle'),
    require('../drawing-elements/sub-squares'),
    require('../drawing-elements/overlap-square'),
    require('../drawing-elements/gap-square'),
    require('../drawing-elements/carpet'),
    require('../drawing-elements/polygon'),
    require('../drawing-elements/polygons'),
    require('../drawing-elements/sub-pentagons'),
    require('../drawing-elements/sub-polygons'),
    require('../drawing-elements/poly-with-colors'),
    require('../drawing-elements/customize-polygons'),
    require('../drawing-elements/fitting'),
    require('../drawing-elements/rotation-test'),
];

drawingElements.forEach(drawingElement => {
    drawingElement.setup();
});

(function (wrap) {
    const initialValue = 3;
    const label = wrap.querySelector('.fitter-value');
    const button = wrap.querySelector('.fit-pi');

    label.innerText = initialValue;

    button.addEventListener('click', () => {
        button.disabled = true;

        const fitter = new Fitter(3);

        const iterator = fitter.fitPromiseIterator((proposedValue) => {
            if (proposedValue === Math.PI) {
                return 0;
            }
            if (proposedValue > Math.PI) {
                return 1;
            } else {
                return -1;
            }
        });

        const fitInterval = setInterval(() => {
            iterator().then(() => {
                label.innerText = fitter.value;
            }).catch(() => {
                label.innerText = fitter.value;
                clearInterval(fitInterval);
                button.disabled = false;
            });
        }, 100);

    });
})(getById('fit-pi'));


